import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {SidebarOptions} from './nav.interfaces';

@Injectable()
export class NavService {

    // Observable option source
    private sidebarOptionsSource = new Subject<SidebarOptions>();

    // Observable option stream
    sidebarOptions$ = this.sidebarOptionsSource.asObservable();

    // Service message option
    updateSidebarOptions(options: SidebarOptions) {
        this.sidebarOptionsSource.next(options);
    }
}



// WEBPACK FOOTER //
// ./src/app/_shared/nav/nav.service.ts